var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-100"},[_c('div',{directives:[{name:"lazy",rawName:"v-lazy:background-image",value:(_vm.background),expression:"background",arg:"background-image"}],staticClass:"jumbotron d-flex",class:[
      _vm.$style.hasBackground,
      _vm.gradient !== null ? _vm.$style.hasGradient : '' ],style:([
      _vm.height !== null ? _vm.heroHeight : '',
      _vm.gradient !== null ? _vm.gradientColor : '' ])},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }